import React from "react";

const JobListContainer = (props) => {
  return (
    <div
      ref={props.devRef}
      onScroll={props.onDevScroll}
      style={{
        flex: 3,
        overflowX: "scroll",
        overflowY: "scroll",
        border: "1px solid lightgrey",
        borderRadius: "5px",
      }}
    >
      {props.children}
    </div>
  );
};

export default JobListContainer;
